/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CheckoutRequest
 */
export interface CheckoutRequest {
    /**
     *
     * @type {string}
     * @memberof CheckoutRequest
     */
    priceId: string;
}

/**
 * Check if a given object implements the CheckoutRequest interface.
 */
export function instanceOfCheckoutRequest(value: object): value is CheckoutRequest {
    if (!('priceId' in value) || value['priceId'] === undefined) return false;
    return true;
}

export function CheckoutRequestFromJSON(json: any): CheckoutRequest {
    return CheckoutRequestFromJSONTyped(json, false);
}

export function CheckoutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutRequest {
    if (json == null) {
        return json;
    }
    return {

        'priceId': json['price_id'],
    };
}

  export function CheckoutRequestToJSON(json: any): CheckoutRequest {
      return CheckoutRequestToJSONTyped(json, false);
  }

  export function CheckoutRequestToJSONTyped(value?: CheckoutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'price_id': value['priceId'],
    };
}
